<template>
  <div class="logo-container">
    <svg 
      :width="width" 
      :height="height" 
      viewBox="0 0 120 40" 
      xmlns="http://www.w3.org/2000/svg"
      class="gac-logo"
    >
      <!-- 背景圆角矩形 -->
      <rect 
        x="2" 
        y="4" 
        width="116" 
        height="32" 
        rx="8" 
        ry="8" 
        fill="url(#gradientBg)"
        stroke="url(#gradientBorder)" 
        stroke-width="1"
      />
      
      <!-- 代码图标 -->
      <g transform="translate(10, 10)">
        <!-- 左括号 -->
        <path 
          d="M2 4 L0 8 L0 12 L2 16" 
          stroke="#ffffff" 
          stroke-width="2" 
          fill="none" 
          stroke-linecap="round"
        />
        <!-- 右括号 -->
        <path 
          d="M14 4 L16 8 L16 12 L14 16" 
          stroke="#ffffff" 
          stroke-width="2" 
          fill="none" 
          stroke-linecap="round"
        />
        <!-- 中间的斜杠 -->
        <path 
          d="M10 2 L6 18" 
          stroke="#ffffff" 
          stroke-width="2" 
          stroke-linecap="round"
        />
      </g>
      
      <!-- GAC 文字 -->
      <text 
        x="36" 
        y="16" 
        font-family="'SF Pro Display', -apple-system, sans-serif" 
        font-size="11" 
        font-weight="700" 
        fill="#ffffff"
        letter-spacing="0.5px"
      >
        GAC
      </text>
      
      <!-- Code 文字 -->
      <text 
        x="36" 
        y="28" 
        font-family="'SF Pro Display', -apple-system, sans-serif" 
        font-size="8" 
        font-weight="500" 
        fill="#e5e7eb" 
        letter-spacing="1px"
      >
        CODE
      </text>
      
      <!-- 中国国旗小图标 -->
      <g transform="translate(85, 8)">
        <rect x="0" y="0" width="24" height="16" rx="2" fill="#ff0000"/>
        <polygon points="3,2 4.5,5 1.5,5" fill="#ffff00"/>
        <polygon points="7,1 7.5,2.5 6.5,2.5" fill="#ffff00"/>
        <polygon points="8,4 8.5,5.5 7.5,5.5" fill="#ffff00"/>
        <polygon points="7,7 7.5,8.5 6.5,8.5" fill="#ffff00"/>
        <polygon points="8,10 8.5,11.5 7.5,11.5" fill="#ffff00"/>
      </g>
      
      <!-- 定义渐变 -->
      <defs>
        <linearGradient id="gradientBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#6366f1;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:1" />
        </linearGradient>
        <linearGradient id="gradientBorder" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#818cf8;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#a78bfa;stop-opacity:1" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'LogoComponent',
  props: {
    width: {
      type: [String, Number],
      default: 120
    },
    height: {
      type: [String, Number],
      default: 40
    }
  }
}
</script>

<style scoped>
.logo-container {
  display: inline-block;
}

.gac-logo {
  transition: transform 0.2s ease;
}

.gac-logo:hover {
  transform: scale(1.05);
}
</style>